import { LooseObject } from '../interface';

export const isObjectDeeplyChanged = (newObj?: LooseObject, oldObj?: LooseObject) =>
    JSON.stringify(newObj) !== JSON.stringify(oldObj);
